export default __webpack_public_path__ + "static/map/img/def_raster.88d7ad8.png";